<template>
  <div class="empty-container">
    <svg class="icon icon-empty" aria-hidden="true">
      <use xlink:href="#icon-kong"></use>
    </svg>
    <p class="empty-text">{{ description || '暂无数据' }}</p>
  </div>
</template>

<script>
  export default {
    name: "bsp-empty",
    props: ['description']
  }
</script>

<style lang="scss" scoped>
  .empty-container {
    padding: 50px;
    text-align: center;
    .icon-empty{
      font-size: 100px;
      color: #dbdbdb;
    }
    .empty-text {
      font-weight: 400;
      color: #dbdbdb;
      margin-top: 15px;
    }
  }
</style>
